import { graphql } from 'app/generated/gql'

// ============================================================================
// All integration option queries are namespaced under `integrationOptions`
// ============================================================================

// ============================================================================
// RingCentral
// ============================================================================

export const RING_CENTRAL_PHONE_NUMBERS_QUERY = graphql(`
  query RingCentralPhoneNumbers($locationId: ID) {
    integrationOptions {
      ringCentralPhoneNumbers(locationId: $locationId) {
        id
        name
        isUsed
      }
    }
  }
`)

// ============================================================================
// CallRail
// ============================================================================

export const CALL_RAIL_COMPANIES_QUERY = graphql(`
  query CallRailCompanies($locationId: ID) {
    integrationOptions {
      callRailCompanies(locationId: $locationId) {
        id
        name
        isUsed
      }
    }
  }
`)

// ============================================================================
// Sikka
// ============================================================================

export const SIKKA_OFFICES_QUERY = graphql(`
  query SikkaOffices($locationId: ID) {
    integrationOptions {
      sikkaOffices(locationId: $locationId) {
        id
        name
        practices {
          id
          name
          isUsed
        }
      }
    }
  }
`)

// ============================================================================
// Ascend
// ============================================================================

export const ASCEND_LOCATIONS_QUERY = graphql(`
  query AscendLocations($locationId: ID) {
    integrationOptions {
      ascendLocations(locationId: $locationId) {
        id
        name
        isUsed
      }
    }
  }
`)

// ============================================================================
// Carestack
// ============================================================================

export const CARESTACK_PRACTICES_QUERY = graphql(`
  query CarestackPractices($locationId: ID) {
    integrationOptions {
      carestackPractices(locationId: $locationId) {
        id
        name
        isUsed
      }
    }
  }
`)

// ============================================================================
// Jotform
// ============================================================================

export const JOTFORM_FORMS_QUERY = graphql(`
  query JotformForms($locationId: ID) {
    integrationOptions {
      jotformForms(locationId: $locationId) {
        id
        name
        labelId
        labelName
        isUsed
        usedByLocationName
      }
    }
  }
`)

// ============================================================================
// Twilio
// ============================================================================

export const TWILIO_PHONE_NUMBERS_QUERY = graphql(`
  query TwilioPhoneNumbers($locationId: ID) {
    integrationOptions {
      twilioPhoneNumbers(locationId: $locationId) {
        id
        name
        isUsed
      }
    }
  }
`)

// ============================================================================
// ElevenLabs
// ============================================================================

export const ELEVEN_LABS_AGENTS_QUERY = graphql(`
  query ElevenLabsAgents {
    integrationOptions {
      elevenLabsAgents {
        id
        name
        isUsed
      }
    }
  }
`)

export const ELEVEN_LABS_BOUND_LOCATIONS_QUERY = graphql(`
  query ElevenLabsBoundLocations {
    locations(pagination: { limit: 1000 }) {
      hits {
        id
        elevenLabsAgentId
      }
    }
  }
`)

export const BIND_LOCATION_ELEVEN_LABS_AGENT = graphql(`
  mutation BindLocationElevenLabsAgent($locationId: ID!, $elevenLabsAgentId: String!) {
    bindLocationElevenLabsAgent(locationId: $locationId, elevenLabsAgentId: $elevenLabsAgentId) {
      id
      elevenLabsAgentId
    }
  }
`)

export const UNBIND_LOCATION_ELEVEN_LABS_AGENT = graphql(`
  mutation UnbindLocationElevenLabsAgent($locationId: ID!) {
    unbindLocationElevenLabsAgent(locationId: $locationId) {
      id
    }
  }
`)
